import React from 'react';
import { useScrollToTopOnParamChange } from 'webHooks/useScrollToTopOnParamChange';

interface Props {
  scrollParamName?: string;
  children: React.ReactNode;
}

const ScrollTopContainer = React.forwardRef((props: Props, ref: any) => {
  useScrollToTopOnParamChange({ paramName: props.scrollParamName, scrollRef: ref });

  return <>{props.children}</>;
});

interface ScrollTopProps extends Props {
  isScrollToTopOnParamChange: boolean;
}

export const ScrollToTopWrapper = React.forwardRef((props: ScrollTopProps, ref) => {
  if (props.isScrollToTopOnParamChange) {
    return <ScrollTopContainer ref={ref} {...props} />;
  }

  return <>{props.children}</>;
});
